import type {OnlineGroundDrop} from '../net/online';
import {itemName} from './huntEconomy';
import {escapeUi} from './uiIcons';
export function groundDropState(drop:OnlineGroundDrop,playerId:string|null,now:number,pending:boolean):{disabled:boolean;reason:string;button:string}{
 if(now>=drop.expiresAt)return {disabled:true,reason:'หมดอายุแล้ว',button:'หมดอายุ'};
 if(drop.ownerId&&drop.ownerId!==playerId&&now<drop.freeAt)return {disabled:true,reason:'สงวนให้เจ้าของชั่วคราว',button:'ยังเก็บไม่ได้'};
 if(pending)return {disabled:true,reason:'กำลังรอ server ยืนยัน',button:'กำลังเก็บ…'};
 return {disabled:false,reason:drop.ownerId===playerId?'ของคุณ':'ของส่วนรวม',button:'เก็บ'};
}
export function groundDropsView(drops:OnlineGroundDrop[],playerId:string|null,now:number,pending:Set<string>):string{
 if(!drops.length)return '';
 return `<section class="inventory-ground-drops"><h3>ของใกล้ตัว</h3>${drops.map(drop=>{
  const state=groundDropState(drop,playerId,now,pending.has(drop.id));
  return `<div class="rpg-row"><span>${escapeUi(itemName(drop.itemId))} ×${drop.quantity}<small>${state.reason}</small></span><button data-rpg="pickup" data-value="${escapeUi(drop.id)}" ${state.disabled?'disabled':''} aria-busy="${pending.has(drop.id)}">${state.button}</button></div>`;
 }).join('')}</section>`;
}
